import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Typography,
} from "@mui/material";
import React, { useState, useEffect } from "react";

import moment from "moment";
import EditEvent from "./edit_event";
import DeletePopup from "../shared/delete_popup";
import AccessLocalStorage from "../../services/localStorage";
import {getApiUrl} from "../../services/api_service";
import ViewEvent from "./view_event";
import { button, carejourneytabcontainer, carejourneytabheading, eventDateTime, eventDetails, eventTitle, pcolor } from "../../style2";

export default function Appointments() {
  const rowsPerPageValue = 4;
  const ls = new AccessLocalStorage();
  const [appointments, setAppointments] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(rowsPerPageValue);
  const [viewMore, setViewMore] = useState(false);

  const [anchorEls, setAnchorEls] = useState([]);
  const [anchorPosition, setAnchorPosition] = useState(null);

  const [openEditAppointment, setOpenEditAppointment] = useState(false);
  const [openViewAppointment, setOpenViewAppointment] = useState(false);
  const [openAddAppointment, setOpenAddAppointment] = useState(false);
  const [openDeletePopup, setOpenDeletePopup] = useState(false);

  const [selectedAppointment, setSelectedAppointment] = useState([]);

  const handleViewMore = () => {
    viewMore ? setViewMore(false) : setViewMore(true);
    viewMore
      ? setRowsPerPage(rowsPerPageValue)
      : setRowsPerPage(appointments.length);
  };

  const handleMenuClick = (event, index) => {
    const newAnchorEls = [...anchorEls];
    newAnchorEls[index] = event.currentTarget;
    setAnchorEls(newAnchorEls);
    const { left, top } = event.currentTarget.getBoundingClientRect();
    setAnchorPosition({ left, top });
  };
  const handleMenuClose = (index) => {
    const newAnchorEls = [...anchorEls];
    newAnchorEls[index] = null;
    setAnchorEls(newAnchorEls);
    setAnchorPosition(null);
  };
  const handleClickOpenEditAppointment = (selectedAppointment, index) => {
    setSelectedAppointment(selectedAppointment);
    setOpenEditAppointment(true);
    //console.log("event edit id:", selectedAppointment.id);
    handleMenuClose(index); // to close the menu after opening the edit popup
  };
  const handleClickOpenViewAppointment = (selectedAppointment) => {
    setSelectedAppointment(selectedAppointment);
    setOpenViewAppointment(true);
    //console.log("event view id:", selectedAppointment.id);
  };
  const handleClickAddAppointment = () => {
    setOpenAddAppointment(true);
  };
  const handleClickCloseAppointment = () => {
    setOpenEditAppointment(false);
    setOpenViewAppointment(false);
    setOpenAddAppointment(false);
    setSelectedAppointment(""); // reset the selected event so the edit dialog will contain new data
  };

  const handleClickDeleteAppointment = (id, index) => {
    handleMenuClose(index);
    setOpenDeletePopup(true);
    setAppointments(
      appointments.filter((appointment) => appointment.id !== id)
    );
    viewMore
      ? setRowsPerPage(rowsPerPageValue)
      : setRowsPerPage(appointments.length);
  };

  const handleClickCloseDeletePopup = () => {
    setOpenDeletePopup(false);
  };
  // const getRandomColor = () => {
  //   const letters = '0123456789ABCDEF';
  //   let color = '#';
  //   for (let i = 0; i < 6; i++) {
  //     color += letters[Math.floor(Math.random() * 16)];
  //   }
  //   return color;
  // };
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const authTokens = localStorage.getItem("authTokens");
    let currentPatient = localStorage.getItem("currentpatient") !== null ? JSON.parse(localStorage.getItem("currentpatient")) : { id : ""};
    let token;

    if (authTokens) {
      const parsedAuthTokens = JSON.parse(authTokens);
      token = parsedAuthTokens?.accessToken;
    }
    if (!token) {
      setError("Unauthorized. No token available.");
      setLoading(false);
      return;
    }
  
    fetch(
      `${getApiUrl()}${
        process.env.REACT_APP_GET_APPOINTMENTS
      }/${ls.getCurrentPatientId()}/${"F9ED8EC3-492D-4839-B9E4-6E7D7912E98A"}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        //console.log(data);
        setAppointments(data);
      })
      .catch((err) => {
        setError(err.message || "An error occurred.");
        setAppointments([]);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <Box style={{ position: "relative", padding:"0px"}}>
      <Grid container>
        <Grid item xs={11}>
          <Typography sx={carejourneytabheading}>Appointments</Typography> 
        </Grid>
        {loading ? <Grid item xs={1}><CircularProgress /></Grid> : null}
      </Grid>
      <Box sx={carejourneytabcontainer}>
        {appointments != null && appointments.length > 0 ? appointments.slice(0, rowsPerPage).map((appointment, index) => {
          return (
            <Grid container direction="row" alignItems="flex-start" key={appointment.id}>
              <Grid item xs={3} sx={eventDateTime} style={{ backgroundColor: appointment.eventSubType.name }}>
                <div onClick={() => handleClickOpenViewAppointment(appointment)} style={{ cursor: "pointer", textAlign:"center" }}>
                  <Typography sx={eventTitle}>
                    {moment(appointment.startDate).format("DD.MM.YYYY")}
                  </Typography>
                  <Typography sx={{fontSize:"14px"}}>
                    {moment(appointment.startDate).format("h:mm A")} -{" "}
                    {moment(appointment.endDate).format("h:mm A")}
                  </Typography>
                </div>
              </Grid>
              <Grid container item xs={9} alignItems="flex-start" justifyContent="space-between"
                style={{...eventDetails, backgroundColor: appointment.eventSubType.name + "40" }} >
                <Grid item xs={7} sm={9} md={10}>
                  <div onClick={() => handleClickOpenViewAppointment(appointment)} style={{ cursor: "pointer" }}>
                    <Typography  sx={{...eventTitle, color:pcolor }}>{appointment.title}</Typography>
                    <Typography sx={{color:"#535353", fontSize:"14px"}}>
                      {appointment.description != null ? appointment.description.length <= 50
                        ? appointment.description
                        : appointment.description.substring(0, 50) + "..." : null}
                    </Typography>
                  </div>
                </Grid>
              </Grid>
            </Grid>
          );
        }) : loading ? null : <Box>No Appointments</Box>}
      </Box>
      <Box m={3} />
      <Grid Container sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
        <Grid item>
          {!viewMore && appointments.length > rowsPerPageValue ? (
            <Button sx={button} onClick={handleViewMore}>
              Show More
            </Button>
          ) : (
            <Box m={4} />
          )}
        </Grid>
      </Grid>
      
      <EditEvent open={openEditAppointment} handleClose={handleClickCloseAppointment} eventType={"Appointment"} eventData={selectedAppointment}/>
      <ViewEvent
        open={openViewAppointment}
        handleClose={handleClickCloseAppointment}
        eventType={"Appointment"}
        eventData={selectedAppointment}
      />
      <EditEvent
        open={openAddAppointment}
        handleClose={handleClickCloseAppointment}
        eventType={"Appointment"}
        eventData={selectedAppointment}
      />
      <DeletePopup
        open={openDeletePopup}
        handleClose={handleClickCloseDeletePopup}
      />
    </Box>
  );
}
